import { createFileRoute, redirect } from "@tanstack/react-router";

// Merged into the fuller /real-estate-broker-property-manager-marketing-colorado page (301 to avoid duplicate pages competing in search).
export const Route = createFileRoute("/real-estate-marketing-colorado")({
  beforeLoad: () => {
    throw redirect({ to: "/real-estate-broker-property-manager-marketing-colorado", statusCode: 301 });
  },
});
